import React from 'react';
import FieldSection from './FieldSection';
import AssetSection from './AssetSection';

const MapAssetFields = ({ asset, readOnly }) => {
  const { fields } = asset || {};
  if (!asset.isAsset) return (
    <FieldSection field={asset} readOnly={readOnly} />
  )
  return (
    <div>
      {(fields || []).map((f, index) => {
        if (f.isAsset) {
          return <AssetSection asset={f} key={index} readOnly={readOnly} />
        }
        return (
          <FieldSection field={f} key={index} readOnly={readOnly} />
        )
      })}
    </div>
  )
};

export default MapAssetFields;


// WEBPACK FOOTER //
// ./src/components/routes/assets/asset-form/MapAssetFields.js